<template>
  <div>
    <div class="showlabel">
      <h4>选择题库</h4>
      <div class="testtype">组件模式：智能组卷</div>
      <div class="testtype">命题方式：统一命题</div>
      <div class="testtype">添加题库</div>
    </div>
    <div class="baic_content">
      <!-- 表单内容 -->
      <div class="hos_table">
        <el-form :v-model="getData">
          <el-table
            :model="getData"
            :data="getData"
            style="width: 100%"
            height="100%"
            :summary-method="getSummaries"
            show-summary
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="titleName" label="题型">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.titleName"
                  class="super_input"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="questionNumber" label="题数">
            </el-table-column>
            <el-table-column prop="score" label="分值">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.score"
                  class="small_input"
                ></el-input
                >分
              </template>
            </el-table-column>
            <el-table-column prop="topicQuantity" label="题量">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.topicQuantity"
                  class="small_input"
                ></el-input
                >题
              </template>
            </el-table-column>
            <el-table-column
              prop="questionsThat"
              label="题型说明"
              width="430px"
            >
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.questionsThat"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button
          class="succ_btn"
          @click="
            cutcoms(1);
            destory();
          "
          >上一步</el-button
        >
        <el-button
          type="success"
          class="submit_btn"
          @click="
            cutcoms(3);
            destory();
          "
          >下一步</el-button
        >
      </div>
    </div>
    <!-- 弹窗 -->
  </div>
</template>

<script>
export default {
  props: ["cutcoms"],
  data() {
    return {
      textarea: "",
      input: "",
      getData: [
        {
          id: 1,
          titleName: "A题型",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        },
        {
          titleName: "X题型",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat:
            "包括题干和正确、错误两个选项。选对得分，错选、不选均不得分。",
        },
        {
          titleName: "填空题",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat: "在下列空格中填入适当内容，使句子意思完整。",
        },
        {
          titleName: "判断题",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        },
        {
          titleName: "名词解释",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        },
        {
          titleName: "问答题",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        },
        {
          titleName: "B题型",
          questionNumber: "100题",
          score: 50,
          topicQuantity: 50,
          questionsThat:
            "包括题干和正确、错误两个选项。选对得分，错选、不选均不得分。",
        },
      ],
    };
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (index == 4) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += " 题";
          }
        } else if (index == 3) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += " 分";
          }
        }
      });

      return sums;
    },
    // 上移
    onmoveup(index, row) {
      var that = this;
      console.log("上移", index, row);
      console.log(that.getData[index]);
      if (index > 0) {
        let upDate = that.getData[index - 1];
        that.getData.splice(index - 1, 1);
        that.getData.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    onmovedown(index, row) {
      var that = this;
      console.log("下移", index, row);
      if (index + 1 === that.getData.length) {
        alert("已经是最后一条，不可下移");
      } else {
        console.log(index);
        let downDate = that.getData[index + 1];
        that.getData.splice(index + 1, 1);
        that.getData.splice(index, 0, downDate);
      }
    },
    destory() {
      this.$destroy();
    },
  },
};
</script>

<style lang="scss" scoped>
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    //background-color: antiquewhite;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.baic_content {
  background-color: white;
  //  margin-top: 24px;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 2px;
  right: 10px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}

.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 100px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.small_input {
  width: 60px !important;
  height: 32px !important;
  font-size: 15px !important;
  margin-right: 10px;
}
.super_input {
  width: 78px !important;
  height: 32px !important;
  font-size: 15px !important;
  > ::v-deep .el-input__inner {
    padding: 0px 8px !important;
    text-align: center;
  }
}
.long_input {
  width: 420px;
  height: 100%;
}
::v-deep .el-input > .el-input__inner {
  height: 32px !important;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(7) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
::v-deep .has-gutter {
  height: 70px;
  tr > td {
    background-color: #f5faff;
  }

  .cell {
    text-align: center;
  }
}
.nomove {
  opacity: 0;
  cursor: auto;
}
</style>